import type { ToolDefinition } from "../types";
import imageConverterTool from "./image-converter";
import imageToBase64Tool from "./image-to-base64";
import imageToPngTool from "./image-to-png";
import imageToJpgTool from "./image-to-jpg";
import imageToJpegTool from "./image-to-jpeg";
import imageToBmpTool from "./image-to-bmp";
import imageToTifTool from "./image-to-tif";
import imageToTiffTool from "./image-to-tiff";
import imageToIcoTool from "./image-to-ico";
import imageToAvifTool from "./image-to-avif";
import base64ToImageTool from "./base64-to-image";
import heicToJpgTool from "./heic-to-jpg";
import imageToHeicTool from "./image-to-heic";
import gifMakerTool from "./gif-maker";

export const conversionTools: ToolDefinition[] = [
  imageConverterTool,
  imageToBase64Tool,
  imageToPngTool,
  imageToJpgTool,
  imageToJpegTool,
  imageToBmpTool,
  imageToTifTool,
  imageToTiffTool,
  imageToIcoTool,
  imageToAvifTool,
  base64ToImageTool,
  heicToJpgTool,
  imageToHeicTool,
  gifMakerTool,
];

export { default as imageConverterTool } from "./image-converter";
export { default as imageToBase64Tool } from "./image-to-base64";
export { default as imageToPngTool } from "./image-to-png";
export { default as imageToJpgTool } from "./image-to-jpg";
export { default as imageToJpegTool } from "./image-to-jpeg";
export { default as imageToBmpTool } from "./image-to-bmp";
export { default as imageToTifTool } from "./image-to-tif";
export { default as imageToTiffTool } from "./image-to-tiff";
export { default as imageToIcoTool } from "./image-to-ico";
export { default as imageToAvifTool } from "./image-to-avif";
export { default as base64ToImageTool } from "./base64-to-image";
export { default as heicToJpgTool } from "./heic-to-jpg";
export { default as imageToHeicTool } from "./image-to-heic";
export { default as gifMakerTool } from "./gif-maker";
